import React from 'react';
import styled from '@emotion/styled';

const ConfirmationText = styled.div`
  margin-top: 12px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #717680;
`;

const ConfirmationLink = styled.a`
  color: #9dbc60 !important;
  text-decoration: underline;
  cursor: pointer;
`;

const PaymentConsentText = () => (
  <ConfirmationText>
    Mit dem Klick bestätige ich die{' '}
    <ConfirmationLink href="/anb" target="_blank">
      Nutzungsbedingungen
    </ConfirmationLink>{' '}
    und{' '}
    <ConfirmationLink href="/datenschutz" target="_blank">
      Datenschutzbestimmungen
    </ConfirmationLink>{' '}
    von commonsplace.
  </ConfirmationText>
);

export default PaymentConsentText;
